var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 6,
    viewBox: "0 0 30 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 3L26.5183 0.989856L26.5183 5.01015L30 3ZM-3.04378e-08 3.34817L26.8665 3.34817L26.8665 2.65183L3.04378e-08 2.65183L-3.04378e-08 3.34817Z",
    fill: "url(#paint0_linear_2606_35776)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2606_35776",
    x1: 36.0484,
    y1: 3.00052,
    x2: -0.227829,
    y2: 2.88319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#054B7D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47659,
    stopColor: "#054B7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#054B7D",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right_arrow.064c96b48fcc86df57f0091506898f41.svg";
export { ForwardRef as ReactComponent };